module.exports = __webpack_public_path__ + "img/CDC3B8_5A3F3C_67545A_8D7769-256px.f728b1fc.png";